import {
  containsSampleTestValue,
  filterSampleTestStrings,
  removeSampleTestFromPayload,
} from "../../excel/mapping/sampleDataFilter";

export {
  containsSampleTestValue,
  filterSampleTestStrings,
} from "../../excel/mapping/sampleDataFilter";

export function removeSampleTestObjects<T>(data: T): T {
  return removeSampleTestFromPayload(data as Record<string, unknown>) as T;
}

export const removeSampleTestArray = (data: string[] | undefined) => {
  if (!data || !Array.isArray(data)) {
    return [];
  }
  return filterSampleTestStrings(data.map(String));
};
